import React from 'react'
import { SurfacePalette, type } from '../tokens'

/**
 * "This slide won't be in the meeting." Three cards say it — the survey card
 * with no Salesforce link (slice 11), and any built-in or custom slide the AE
 * hid by hand (slice 12.5) — so the pill is one component rather than three
 * blocks of inline styling.
 *
 * `title` carries the *reason*, which differs per card; the chip itself never
 * explains why.
 */
export const HiddenFromClientChip = ({
  palette,
  title,
}: {
  palette: SurfacePalette
  title?: string
}) => (
  <span
    title={title}
    style={{
      flexShrink: 0,
      padding: '2px 8px',
      borderRadius: 999,
      border: `1px solid ${palette.hairline}`,
      background: palette.surface,
      color: palette.textMuted,
      fontFamily: type.family.mono,
      fontSize: 10,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    }}
  >
    Hidden from the client
  </span>
)
